import { render } from "./ViewDemandePrix.vue?vue&type=template&id=62b30222&ts=true"
import script from "./ViewDemandePrix.vue?vue&type=script&lang=ts"
export * from "./ViewDemandePrix.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__